module.exports = __webpack_public_path__ + "static/media/slider-digital-agency-slide-02-bg.ee554567.jpg";